// Field of study, university and other option sets from the Penda application form.
// These are the values stored with an application; what the user sees is their label
// from the language catalog ("values" section, see valueLabel in @/i18n).

export const UNIVERSITIES = [
  "Ss. Cyril and Methodius University",
  "Mother Teresa University in Skopje",
  "State University of Tetova",
  "South East European University",
  "International Balkan University",
  "St. Clement of Ohrid University of Bitola",
  "Goce Delčev University of Štip",
  "University of Information Science and Technology \"St. Paul The Apostle\"",
  "European University",
  "FON University",
  "MIT University Skopje",
  "International University of Struga",
  "Other",
];

export const FIELDS_OF_STUDY = [
  "Arts (Design, Performing arts, Visual arts, etc.)",
  "Architecture",
  "Social sciences (Psychology, Sociology, Political science, etc.)",
  "Law",
  "Medicine",
  "Journalism, media studies and communication",
  "Natural sciences (Biology, Chemistry, Mathematics, Physics, etc.)",
  "Economics (Business administration, Finance, Banking, Management, etc.)",
  "Engineering & Technology (Computer sciences, Civic/Mechanical engineering, etc.)",
  "Humanities (History, Geography, Philosophy, Languages, Education, etc.)",
];

// Cascading LoV: Field of Study -> Faculty/School/Department -> Study program.
// "Other" is available at each level to allow free-text entry when not listed.
export const ACADEMIC_STRUCTURE = {
  "Arts (Design, Performing arts, Visual arts, etc.)": {
    "Faculty of Fine Arts": ["Painting", "Sculpture", "Graphic Design", "Visual Arts"],
    "Faculty of Music Arts": ["Performing Arts", "Musicology", "Composition"],
    "Faculty of Dramatic Arts": ["Acting", "Film & Television Directing"],
  },
  "Architecture": {
    "Faculty of Architecture": ["Architecture", "Urban Planning", "Interior Design"],
    "Faculty of Civil Engineering and Architecture": ["Architecture", "Landscape Architecture"],
  },
  "Social sciences (Psychology, Sociology, Political science, etc.)": {
    "Faculty of Philosophy": ["Psychology", "Sociology", "Social Work", "Pedagogy"],
    "Faculty of Political Science": ["Political Science", "Public Administration", "International Relations"],
    "Faculty of Social Sciences": ["Psychology", "Social Policy"],
  },
  "Law": {
    "Faculty of Law": ["Law", "Criminal Justice", "International Law"],
    "Faculty of Law and Political Science": ["Law", "Public Administration"],
  },
  "Medicine": {
    "Faculty of Medicine": ["General Medicine", "Dentistry", "Pharmacy"],
    "Faculty of Medical Sciences": ["General Medicine", "Dental Medicine", "Nursing", "Physiotherapy"],
    "Faculty of Pharmacy": ["Pharmacy", "Clinical Pharmacy"],
  },
  "Journalism, media studies and communication": {
    "Faculty of Journalism and Communication": ["Journalism", "Public Relations", "Media Studies"],
    "Faculty of Communication Sciences": ["Communication", "Digital Media"],
  },
  "Natural sciences (Biology, Chemistry, Mathematics, Physics, etc.)": {
    "Faculty of Natural Sciences and Mathematics": ["Biology", "Chemistry", "Mathematics", "Physics", "Geography"],
    "Faculty of Sciences": ["Environmental Science", "Biochemistry"],
  },
  "Economics (Business administration, Finance, Banking, Management, etc.)": {
    "Faculty of Economics": ["Business Administration", "Finance", "Accounting", "Marketing"],
    "Faculty of Business and Economics": ["Finance", "Banking", "Management", "International Business"],
    "Faculty of Management": ["Management", "Entrepreneurship"],
  },
  "Engineering & Technology (Computer sciences, Civic/Mechanical engineering, etc.)": {
    "Faculty of Computer Science and Engineering": ["Software Engineering", "Computer Science", "Information Systems", "Data Science"],
    "Faculty of Electrical Engineering and Information Technologies": ["Electrical Engineering", "Telecommunications", "Computer Engineering"],
    "Faculty of Mechanical Engineering": ["Mechanical Engineering", "Automotive Engineering", "Industrial Engineering"],
    "Faculty of Civil Engineering": ["Civil Engineering", "Geodesy", "Structural Engineering"],
  },
  "Humanities (History, Geography, Philosophy, Languages, Education, etc.)": {
    "Faculty of Philology": ["English Language and Literature", "Albanian Language and Literature", "Macedonian Language and Literature", "German Language"],
    "Faculty of Philosophy": ["History", "Philosophy", "History of Art"],
    "Faculty of Pedagogy": ["Primary Education", "Preschool Education", "Special Education"],
  },
};


export const HOW_HEARD = [
  "Friends and family",
  "Social Media (Facebook, Instagram)",
  "Email (shared via Student Services of your university)",
  "Other",
];

// Labels and hints: ui.documents.<key> in the language catalog.
export const DOCUMENT_FIELDS = [
  { key: "proof_admission", required: false },
  { key: "cv", required: true },
  { key: "motivation_letter", required: true },
  { key: "recommendation_1", required: true },
  { key: "recommendation_2", required: true },
  { key: "transcript", required: true },
  { key: "id_passport", required: true },
  { key: "income_certificate", required: true, multiple: true },
  { key: "additional_docs", required: false },
  { key: "sibling_student_id", required: false },
  { key: "divorce_statement", required: false },
  { key: "death_certificate", required: false },
];

// Evaluator review criteria (labels: ui.criteria.<key>, short labels: ui.criteria_short.<key>).
// Scores are 1-10 and make up the overall average; choice criteria are answered yes/maybe/no.
export const REVIEW_CRITERIA = ["financial_part", "overall_success", "submitted_documentation", "invited_to_interview"];
export const CHOICE_CRITERIA = ["invited_to_interview"];
export const isChoice = (key) => CHOICE_CRITERIA.includes(key);
export const CHOICES = ["yes", "maybe", "no"]; // labels: ui.choices.<value>
